import { base } from 'viem/chains'

import { useActiveOrgId } from '~/hooks/org'
import { useOrgBalances } from '~/hooks/useBalances'
import { useSmartAccounts } from '~/hooks/useSmartAccounts'
import { IAddress, OrgSmartAccount, SmartAccountRole } from '~/types'
import { Address } from '~/utils/address'
import { AAVE_BASE_USDC, isAutoEarnV1Enabled } from '~/utils/vault'

export const useEarnMigration = (account: OrgSmartAccount | undefined) => {
  const orgId = useActiveOrgId()
  const { smartAccounts } = useSmartAccounts()
  const { balances, isLoading } = useOrgBalances(orgId)

  const hasLegacyEarnBalance = (address: IAddress) =>
    !!balances[address]?.balances.some(
      (balance) =>
        balance.chainId === base.id &&
        Address.format(balance.address) === AAVE_BASE_USDC &&
        balance.amount > 0n,
    )

  const orgNeedsMigration = smartAccounts.some(
    (smartAccount) =>
      isAutoEarnV1Enabled(smartAccount) ||
      hasLegacyEarnBalance(smartAccount.address),
  )

  return {
    isLoading,
    show:
      orgNeedsMigration &&
      (account?.role === SmartAccountRole.TREASURY ||
        (!!account && hasLegacyEarnBalance(account.address))),
  }
}
